<template>
	<div>
		<div class="doctorPage doctorSeach">
			<div class="selectSearch" v-if="!splitScreen">
				<el-form ref="form" :model="listParameter" class="qcFrom" :inline="true">
					<el-form-item label="状态" v-if="routers.indexOf('experts')>-1">
					    <el-select v-model="listParameter.status" @change="selectChanged" placeholder="请选择" size="mini" class="name" >
					    <!--  <el-option label="待质控" value="15" v-if="routers.indexOf('doctor')>-1"></el-option>
						  <el-option label="进行中" value="20" v-if="routers.indexOf('doctor')>-1"></el-option> -->
					      <el-option label="待质控" value="15,20" v-if="routers.indexOf('experts')>-1"></el-option>
					      <el-option label="已完成" value="50"></el-option>
						  <el-option label="已取消" value="-1" v-if="routers.indexOf('experts')>-1"></el-option>
					    </el-select>
					  </el-form-item>
					<el-form-item label="任务编号" v-if="routers.indexOf('experts')>-1">
						<el-input v-model="listParameter.keyName" class="name" placeholder="请输入任务编号/名称" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="关键词" v-else>
						<el-input v-model="listParameter.keyName" class="name" placeholder="名称/评分方案" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" v-model="pickerDate.date" type="monthrange" @change="datePicker" size="mini" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy/MM" format='yyyy-MM'>
						</el-date-picker>
					</el-form-item>
					<el-form-item>
					<el-button type="primary" @click="search" round>查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 中间内容 -->
			<div class="centerHome" :class="splitScreen?'centerHomeActive':''">
				<div class="closeSplitScreen el-icon-circle-close" v-if="splitScreen" @click="closeSplitScreen"></div>
				<div class="closePrevious el-icon-circle-close" v-if="splitScreen" @click="backToPageUp"></div>
				<div class="ccHomel" v-if="!splitScreen">
					<div class="compentTable">
						<div v-if="routers.indexOf('doctor')>-1">
							<presentation-table />
						</div>
						<div v-if="routers.indexOf('experts/pending')>-1">
							<expertgroup-table />
						</div>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next" :total="total" :page-size='listParameter.PageCount' :current-page='listParameter.PageIndex' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import doctorReport from '../../components/doctorReport.vue'
	import doctorGrade from '../../components/doctorGrade.vue'
	import expertgroupTable from '../../components/experts/expertgroupTable.vue'
	import presentationTable from '../../components/doctor/presentationTable.vue'
	
	export default {
		data() {
			return {
				routers: '',
			}
		},
		components: {
			doctorReport,
			doctorGrade,
			expertgroupTable, //质控专家待质控
			presentationTable,//审核医生任务列表
		},
		watch: {
			$route(to, from) {
				//初始化
				this.clearInit()
				// this.setRouter(to.path);
				this.routers = to.path;
			}
		},
		computed: {
			...Vuex.mapState('doctor', ['expertinfoTaskListArr','list', 'total', 'listParameter', 'pickerDate', 'experListShow','TaskListArr','taskListShow','loading','splitScreen','statusList']),
		},
		mounted() {
			this.$nextTick(function() {
				this.routers = this.$route.path;
				if(this.$route.path.indexOf('doctor') > -1){
					this.doctorDoctorStatus(50);
				}
			})
		},
		methods: {
			...Vuex.mapMutations('doctor', ['setTabShow','currentChanges', 'setSearch', 'setDatePicker', 'setReportGuid', 'setDoctorType', 'doctorDoctorStatus', 'clearInit', 'setIsSubmint', 'experListShowMu','taskListShowMu', 'setSplitScreen','exportDoctorStatus','exportDoctorStatusMu','setLoading']),
			...Vuex.mapMutations('managerPlanList', ['clearInit', 'setDoctorStatus', 'setDatePicker']),
			...Vuex.mapActions('doctor', ['GetReporterReportList', 'GetExpertTaskList', 'GetDashboradExpert','GetTaskList','expertinfoGetTaskList']),
			selectChanged(value){
				this.setLoading(true);
				this.doctorDoctorStatus(value);
				if(this.$route.path.indexOf('doctor') > -1){
					this.GetTaskList();
				}
				if(this.$route.path.indexOf('experts') > -1){
					if(value == '15,20'){
						this.setTabShow(true);
					}else{
						this.setTabShow(false);
					}
					this.expertinfoGetTaskList();
				}
			},
			//分页
			currentChange(val) {
				this.setLoading(true);
				this.currentChanges(val)
				this.listParameter.status = this.statusList;
				this.doctorDoctorStatus(this.statusList)
				if(this.$route.path.indexOf('doctor') > -1){
					this.GetTaskList();
				}
				if(this.$route.path.indexOf('experts') > -1){
					this.expertinfoGetTaskList();
				}
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//搜索
			search() {
				this.setLoading(true);
				this.currentChanges(1)
				if(this.routers.indexOf('doctor') > -1) {
					this.TaskListArr.startDate = this.pickerDate.date[0];
					this.TaskListArr.endDate = this.pickerDate.date[1];
					this.GetTaskList();
				}
				if(this.routers.indexOf('experts') > -1) {
					this.expertinfoTaskListArr.startDate = this.pickerDate.date[0];
					this.expertinfoTaskListArr.endDate = this.pickerDate.date[1];
					this.expertinfoGetTaskList()
				}
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//创建日期
			datePicker(event) {
				this.setDatePicker(event)
			},
			//关闭分屏
			closeSplitScreen() {
				this.setLoading(false);
				this.setSplitScreen(false);
				this.experListShowMu(false);
				this.taskListShowMu(false);
			},
			//返回
			backToPageUp() {
				if (this.routers.indexOf('doctor') > -1) {
					this.taskListShowMu(true);
					this.GetReporterReportList()
				}else{
					this.experListShowMu(true);
					this.GetExpertTaskList()
				}
				this.setSplitScreen(false);
				
			}
		}

	}
</script>